import React from 'react';
import {Row, Col} from "antd";
import CustomerBaseDisplayDescriptions from './CustomerBaseDisplayDescriptions';
import CustomerBaseDisplayCards from './CustomerBaseDisplayCards';
import CustomerBaseAppointmentCards from './CustomerBaseAppointmentCards';
import CustomerBaseTotalIncome from './CustomerBaseTotalIncome';

const CustomerBaseDisplayContainer = ({baseData}) => {

    const marginBottom = {
        marginBottom: '64px'
    };

    const marginTop = {
        marginTop: '32px'
    };

    const getTotalIncome = () => {
        const positives = baseData.cbs.filter(item => item.bidStatus === 'POSITIVE');
        if(positives && positives[0].customerBidDTOS?.length) {
            return positives[0].customerBidDTOS;
        }

        return [];
    };

    return(
        <React.Fragment>
            <Row style={{...marginBottom,...marginTop}}>
                <Col span={24}>
                    <CustomerBaseDisplayDescriptions descriptionData={baseData}/>
                </Col>
            </Row>
            <Row style={marginBottom}>
                {
                    baseData.cbs.length ?
                        getTotalIncome().map((item, idx) => {
                            return(
                                <Col span={4} key={`customer-report-base-income-${idx}`}>
                                    <CustomerBaseTotalIncome label={`${item.cr}-CİRO`} value={item.pet}/>
                                </Col>
                            )
                        }) : null
                }
                {
                    baseData.ca.length 
                    ? baseData.ca.map((apointment, idx) => {
                        return(
                            <Col span={4} key={`customer-report-base-apointment-${idx}`}>
                                <CustomerBaseAppointmentCards data={apointment} />
                            </Col>
                        )
                    }) 
                    : null
                }
            </Row>
            <Row justify={'space-between'} style={marginBottom}>
                <CustomerBaseDisplayCards data={baseData.cbs}/>
            </Row>
        </React.Fragment>
    )
}
export default CustomerBaseDisplayContainer;
